/**
 * Hides projected-playouts UI for companies that sell 100% by impressions
 * (session `company.cpm_type === 'cpmi'`). `fallback` renders in its place.
 * The flag comes from redux through HiddenByCpmTypeContainer.
 */
const HiddenByCpmType = ({ isCpmi, children = null, fallback = null }) =>
  isCpmi ? fallback : children;

export default HiddenByCpmType;
